import dynamic from 'next/dynamic';
import Image from 'next/image';
import { clsx } from 'clsx';

import { DISTRIBUTOR_NAME, ENV } from '@autopass-web/domain';

import { CURRENT_DISTRIBUTOR } from '../../../new-distributor-config';
import amplitude from '../../../service/amplitude';
import piCtaImage from './pi-cta-image.png';

import type {
  BasePoiCharacteristics,
  FilterOptions,
  PinType,
} from '@autopass-web/feature-maps';
import type { Poi } from '@autopass-web/types';

const URLS = {
  production:
    'https://www.piapp.com.tw/app/download?type=PARKING_FEE_AUTO_PAYMENT',
  development:
    'https://ap-test.piapp.com.tw/app/download?type=PARKING_FEE_AUTO_PAYMENT',
} as const;

const PI_URL = URLS[ENV];

const FeatureMaps = dynamic(() => import('@autopass-web/feature-maps'), {
  ssr: false,
});

const PiCtaButton = () => {
  return (
    <Image
      className={clsx(
        'min-h-80px',
        'rounded-none',
        'bg-inherit',
        'filter-[drop-shadow(0_4px_4px_rgba(0,0,0,0.25))]',
        'shadow-none',
        'pointer-events-auto',
        'cursor-pointer',
      )}
      onClick={() => {
        amplitude.map_CTAButton_click();
        window.open(PI_URL);
      }}
      width={60}
      height={80}
      src={piCtaImage}
      alt="map-cta-button"
    />
  );
};

export const EnterprisePiMapPage = () => {
  return (
    <div className={clsx('w-full', 'h-[100dvh]', 'relative')}>
      <FeatureMaps
        basePath="/maps"
        isNextModule
        events={{ distributorName: DISTRIBUTOR_NAME[CURRENT_DISTRIBUTOR] }}
        parsePinType={parsePinType}
        customFilterOptions={MAP_CUSTOM_FILTER_OPTIONS}
        basePoiCharacteristics={MAP_BASE_POI_CHARACTERISTICS}
        externalWidgets={{
          ctaButton: <PiCtaButton />,
        }}
      />
    </div>
  );
};

const MAP_BASE_POI_CHARACTERISTICS = {
  parkinglot: {
    cooperationStates: ['in_cooperated'],
  },
} as BasePoiCharacteristics;

const MAP_CUSTOM_FILTER_OPTIONS = {
  parkinglot: {
    vehicleTypes: ['car', 'moto'],
  },
} as FilterOptions;

function parsePinType(poi: Poi): PinType {
  switch (poi.type) {
    case 'Parkinglot': {
      const { cooperation_state } = poi;
      if (cooperation_state === 'in_cooperated') return 'parkinglot-autopass';
      return 'parkinglot';
    }
    default:
      throw new Error(`parsePinType: Invalid poi type ${poi.type}`);
  }
}
